var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "input-array",
    },
    [
      _c(
        "span",
        {
          staticClass: "sr-only",
          attrs: {
            "aria-live": "assertive",
          },
        },
        [_vm._v(_vm._s(_vm.assistiveLive))]
      ),
      _vm._v(" "),
      _c(
        "draggable",
        {
          staticClass: "clean options",
          attrs: {
            handle: ".dragarea",
            tag: "ol",
          },
          model: {
            value: _vm.options,
            callback: function callback($$v) {
              _vm.options = $$v
            },
            expression: "options",
          },
        },
        _vm._l(_vm.options, function (option, index) {
          return _c(
            "li",
            {
              key: index,
            },
            [
              _vm.options.length > 1
                ? _c(
                    "a",
                    {
                      ref: "draghandle_" + index,
                      refInFor: true,
                      staticClass: "dragarea",
                      attrs: {
                        tabindex: "0",
                        title: _vm.$gettextInterpolate(
                          "Sortierelement für Option %{option}. Drücken Sie die Tasten Pfeil-nach-oben oder Pfeil-nach-unten, um dieses Element in der Liste zu verschieben.",
                          {
                            option: option,
                          }
                        ),
                      },
                      on: {
                        keydown: function keydown($event) {
                          return _vm.keyHandler($event, index)
                        },
                      },
                    },
                    [
                      _c("span", {
                        staticClass: "handle",
                      }),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.options[index],
                    expression: "options[index]",
                  },
                ],
                ref: "option_" + index,
                refInFor: true,
                attrs: {
                  type: "text",
                  placeholder: _vm.$gettext("Option"),
                },
                domProps: {
                  value: _vm.options[index],
                },
                on: {
                  paste: function paste(ev) {
                    return _vm.onPaste(ev, index)
                  },
                  input: function input($event) {
                    if ($event.target.composing) {
                      return
                    }

                    _vm.$set(_vm.options, index, $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "as-link",
                  attrs: {
                    title: _vm.$gettext("Option löschen"),
                  },
                  on: {
                    click: function click($event) {
                      $event.preventDefault()
                      return _vm.askForDeletingOption(index)
                    },
                  },
                },
                [
                  _c("studip-icon", {
                    attrs: {
                      shape: "trash",
                      role: "clickable",
                      size: 20,
                      alt: "",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              index == _vm.options.length - 1
                ? _c(
                    "button",
                    {
                      staticClass: "as-link",
                      attrs: {
                        title: _vm.$gettext("Option hinzufügen"),
                      },
                      on: {
                        click: function click($event) {
                          $event.preventDefault()
                          return _vm.addOption.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("studip-icon", {
                        attrs: {
                          shape: "add",
                          role: "clickable",
                          size: 20,
                          alt: "",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.askForDeleting
        ? _c("studip-dialog", {
            attrs: {
              title: _vm.$gettext("Bitte bestätigen Sie die Aktion."),
              question: _vm.$gettext("Wirklich löschen?"),
              confirmText: _vm.$gettext("Ja"),
              closeText: _vm.$gettext("Nein"),
              closeClass: "cancel",
              height: "180",
            },
            on: {
              confirm: _vm.deleteOption,
              close: function close($event) {
                _vm.askForDeleting = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }